import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAddQuizMutation, useEditQuizMutation } from '../../../redux/features/quiz/quizApi';
import Error from "../../ui/Error";
import OptionInput from './OptionInput';



const stringSorter = (string, letterQYT) => ((string.length > letterQYT) ? string.slice(0, letterQYT) + "..." : string)

export default function AssignmentForm({ handleOut, videos }) {
    const { isEdit, data } = useSelector((state) => state.edit) || {};

    // form local state
    const [input, setInput] = useState({
        question: "",
        video: videos[0]?.id,
    });
    const [optionA, setOptionA] = useState({
        isCorrect: false,
        option: "",
        id: 1
    });
    const [optionB, setOptionB] = useState({
        isCorrect: false,
        option: "",
        id: 2
    });
    const [optionC, setOptionC] = useState({
        isCorrect: false,
        option: "",
        id: 3
    });
    const [optionD, setOptionD] = useState({
        isCorrect: false,
        option: "",
        id: 4
    });
    const [errorState, setError] = useState(false);

    // mutation hooks
    const [addQuiz, { isError, isSuccess }] = useAddQuizMutation();
    const [editQuiz, { isError: isErrorEdit, isSuccess: isSuccessEdit }] = useEditQuizMutation();


    const changeHandler = (e) => {
        setInput((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }))
    }


    const submitHandler = (e) => {
        setError(false)
        e.preventDefault();

        const video_title = videos.find(item => item.id === Number(input.video)).title
        const video_id = Number(input.video)

        // if minimum one option is correct then submit
        if (optionA.isCorrect || optionB.isCorrect || optionC.isCorrect || optionD.isCorrect){

            if (isEdit) {
                editQuiz({
                    id: data?.id,
                    data: {
                        id: data.id,
                        question: input.question,
                        video_id,
                        video_title,
                        options: [optionA, optionB, optionC, optionD]
                    }
                })
            } else {
                addQuiz({
                    question: input.question,
                    video_id,
                    video_title,
                    options: [optionA, optionB, optionC, optionD]
                })
            }
        }
        // all options false error
        else{
            setError("At least one option should be correct")
        }
    }
    // error state set 
    useEffect(() => {
        if (isError || isErrorEdit) { setError("There was and error") }
        if (isSuccess || isSuccessEdit) { handleOut(false) }
    }, [handleOut, isError, isErrorEdit, isSuccess, isSuccessEdit])


    // edit mode set data to form state
    useEffect(() => {
        if (isEdit) {
            setInput({
                question: data?.question,
                video: data?.video_id
            })
            setOptionA(data?.options[0])
            setOptionB(data?.options[1])
            setOptionC(data?.options[2])
            setOptionD(data?.options[3])
        }

    }, [data, isEdit])

    return (
        <>
            {errorState && <Error message={errorState} />}
            <form onSubmit={submitHandler} className="mt-5 p-6">
                <div className="mb-6">
                    <label htmlFor="question" className="block mb-2 text-sm font-medium text-white">Quiz Question</label>
                    <input name='question' type="text" id="question" className="border  text-sm rounded-lg  block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required
                        value={input.question}
                        onChange={changeHandler}
                    />
                </div>
                <div className="mb-6">
                    <label htmlFor="video" className="block mb-2 text-sm font-medium text-white">Associated Video</label>
                    <select type="text" id="video" name='video' className="border  text-sm rounded-lg  block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required
                        value={input.video}
                        onChange={changeHandler}>

                        {videos.map(video =>
                            <option key={video.id}
                                value={video.id}>
                                {stringSorter(video.title, 80)}
                            </option>
                        )}
                    </select>
                </div>
                <div className="grid gap-6 md:grid-cols-2 mb-6">
                    <OptionInput option={optionA} setOption={setOptionA} label={"A"}/>
                    <OptionInput option={optionB} setOption={setOptionB} label={"B"} />
                    <OptionInput option={optionC} setOption={setOptionC} label={"C"} />
                    <OptionInput option={optionD} setOption={setOptionD} label={"D"} />
                </div>
                <button type="submit" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Submit</button>
            </form>
        </>
    )
};